<template>
  <button class="combine-pay-btn"
          type="button"
          @click="toCombinePay">

    <icon-wallet class="icon-wallet"
                 :color="color" />

    <span class="btn-txt"
          :style="{color: color}">合并支付</span>

  </button>
</template>

<script>
import IconWallet from "./Icon/IconWallet";
export default {
  name: "CombinePayBtn",
  components: { IconWallet },
  data () {
    return {
      color: '#394BE5'
    }
  },

  methods: {
    toCombinePay () {
      this.$router.push({ name: 'combinePay' })
    },
  },
}
</script>

<style scoped lang="scss">
button {
  outline: none;
  border: 0;
  background-color: #fff;
  padding: 0;
}
.combine-pay-btn {
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 0.6rem;
  height: 0.6rem;
  box-shadow: 0 0.02rem 0.07rem rgba(219, 223, 255, 1);
  position: fixed;
  bottom: 1.98rem;
  right: 0.16rem;
  z-index: 30;
  padding: 0;

  .icon-wallet {
    width: 0.26rem;
    height: 0.26rem;
    margin-bottom: 0.02rem;
    flex-shrink: 0;
  }

  .btn-txt {
    font-size: 0.1rem;
    display: block;
  }
}
</style>